import styled from 'styled-components';

export const StyledContactFormCard = styled.div`
  max-height: 100vh;
  .card-body {
    padding: 0;
  }
`;
